import { MarketType, OperationType, Ticket } from "./Entity";

export class Margin extends Ticket {
  // Dados Carteira

  portfolioDocument: string = null;
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount: string = null;
  portfolioName: string = null;
  portfolioClearingAccount: string = null;
  portfolioCode: string = null;
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  marketTypeId: MarketType = null;
  operationTypeId: OperationType = null;
  amount: number = null;
  unitPrice: number = null;
  operationValue: number = null;
  securityType: string = null;
  securityName: string = null;
  securityCode: string = null;
  expirationDate: Date = null;
  settlementDate: Date = null;
  issueDate: Date = null;
  securitySourceId: string = null;
  purchaseDate: Date = null;
  command = "0";
  quotation: number = null;
  asset: string = null;

  hasSameOwnership: boolean;

  bank: string = null;
  branch: string = null;
  account: string = null;

  issuer: string = null;

  // Contraparte
  counterpartName: string = null;
  counterpartDocument: string = null;
  counterpartClearingAccount: string = null;
  counterpartBrokerAccount: string = null;
  isNewCounterpart: boolean;

  // Observacoes
  annotations: string = null;

  transferStatusDescription: string = null;
}
